import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const title = "Impala";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "DefaultLayout",
    component: () => import("../layouts/default.vue"),
    children: [
      {
        path: "/sign-in",
        name: "SignIn",
        component: () => import("../views/auth/SignIn.vue"),
        meta: {
          requiresAuth: false,
          title: "Sign In | " + title,
        },
      },
      {
        path: "/sign-up",
        name: "SignUp",
        component: () => import("../views/auth/SignUp.vue"),
        meta: {
          requiresAuth: false,
          title: "Sign Up | " + title,
        },
      },
      {
        path: "/forgot-password",
        name: "ForgotPassword",
        component: () => import("../views/reset-password/ForgotPassword.vue"),
        meta: {
          requiresAuth: false,
          title: "Forgot Password | " + title,
        },
      },
      {
        path: "/check-mail",
        name: "CheckMail",
        component: () => import("../views/reset-password/CheckMail.vue"),
        meta: {
          requiresAuth: false,
          title: "Check mail | " + title,
        },
      },
      {
        path: "/loading",
        name: "Loading",
        component: () => import("../components/layouts/LoadingPage.vue"),
        meta: {
          title: "Loading | " + title,
        },
      },
      {
        path: "/:pathMatch(.*)*",
        name: "ErrorPage",
        component: () => import("../views/ErrorPage.vue"),
        meta: {
          title: "Error | " + title,
        },
      },
      {
        path: "/",
        component: () => import("../views/AuthenticatedPageWrapper.vue"),
        meta: {
          requiresAuth: true,
          title: title,
        },
        children: [
          {
            name: "Secured",
            path: "/",
            redirect: { name: "Projects" },
          },
          {
            name: "Projects",
            path: "/projects",
            component: () => import("../views/projects/Index.vue"),
            meta: { title: "Projects | " + title },
          },
          {
            name: "CreateProject",
            path: "/projects/create",
            component: () => import("../views/projects/Create.vue"),
            meta: { title: "Create Project | " + title },
          },
          {
            name: "EditProject",
            path: "/projects/edit",
            component: () => import("../views/projects/Edit.vue"),
            meta: { title: "Edit Project | " + title },
          },
          {
            name: "Project",
            path: "/projects/:projectId",
            component: () => import("../views/projects/Show.vue"),
            meta: { title: "Project | " + title },
          },
          {
            name: "CreateStimuli",
            path: "/create-stimuli",
            component: () => import("../views/projects/stimuli/Create.vue"),
            meta: { title: "Create Stimuli | " + title },
          },
          {
            name: "EditStimuli",
            path: "/edit-stimuli/:stimulId",
            component: () => import("../views/projects/stimuli/Create.vue"),
            meta: { title: "Create Stimuli | " + title },
          },
          {
            name: "Credits",
            path: "/credits",
            component: () => import("../views/Credits.vue"),
            meta: { title: "Edit  | " + title },
          },
          {
            path: "/blog",
            name: "Blog",
            component: () => import("../views/blog/Index.vue"),
            meta: {
              requiresAuth: false,
              title: "Blogs | " + title,
            },
          },
          {
            path: "/blog/:blogId",
            name: "BlogShow",
            component: () => import("../views/blog/Show.vue"),
            meta: {
              requiresAuth: false,
              title: "Blog | " + title,
            },
          },
        ],
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
